import React from "react";
import { bool, string, func } from "prop-types";
import { Modal, Row, Col, Button } from "react-bootstrap";
import queryString from "query-string";
import criteriaLinkedInIntegrationImage from "../../../resources/images/criteria_linkedin.png";

const LinkedInIntegrationAuthorizedModal = ({
  liOnboarding,
  showLinkedInAuthorizeModal,
  onAuthorizeLinkedInIntegration,
  linkedInUserEmail,
  loginToken,
}) => {
  const queryParams = queryString.parse(window.location.search);

  const handleReturnToLinkedInTalentHub = () => {
    // use redirectUrl parameter in the query string to redirect to LinkedIn Talent Hub
    window.location.href = queryParams.redirectUrl;
  };

  const handleAuthorizeLinkedInIntegration = () => {
    const liOnboardingIntegrationData = liOnboarding ? queryParams : null;

    liOnboardingIntegrationData.userConfirmation = true;

    onAuthorizeLinkedInIntegration(
      loginToken,
      linkedInUserEmail,
      liOnboardingIntegrationData
    );
  };

  return (
    <Modal
      centered
      show={showLinkedInAuthorizeModal}
      onHide={handleReturnToLinkedInTalentHub}
    >
      <Modal.Header closeButton style={{ borderBottom: "none" }}></Modal.Header>
      <Modal.Body className="mx-auto pt-0">
        <Row>
          <Col className="text-center">
            <div className="mb-3">
              <img
                src={criteriaLinkedInIntegrationImage}
                alt="criteria and linkedin logos"
              />
            </div>
            <h3 className="mb-3" style={{ fontSize: "16px" }}>
              {linkedInUserEmail}
            </h3>
            <p className="mb-4" style={{ color: "#828283", fontSize: "14px" }}>
              Are you sure you want to authorize LinkedIn Talent Hub to access
              your CriteriaCorp account?
            </p>
            <div>
              <Button
                variant="primary"
                style={{ minWidth: "200px" }}
                id="authorizeLinkedInIntegration"
                className="mb-1"
                type="button"
                onClick={handleAuthorizeLinkedInIntegration}
              >
                Authorize
              </Button>
            </div>
            <div>
              <Button
                variant="outline-primary"
                style={{ minWidth: "200px" }}
                id="returnToLinkedInTalentHubBtn"
                className="mb-3"
                type="button"
                onClick={handleReturnToLinkedInTalentHub}
              >
                Return to LinkedIn Talent Hub
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

LinkedInIntegrationAuthorizedModal.propTypes = {
  liOnboarding: bool,
  showLinkedInAuthorizeModal: bool,
  onAuthorizeLinkedInIntegration: func,
  linkedInUserEmail: string,
  loginToken: string,
};

export default LinkedInIntegrationAuthorizedModal;
